import { render, staticRenderFns } from "./SignupFormCard.vue?vue&type=template&id=16ddd5e6&scoped=true&"
import script from "./SignupFormCard.vue?vue&type=script&lang=js&"
export * from "./SignupFormCard.vue?vue&type=script&lang=js&"
import style0 from "./SignupFormCard.vue?vue&type=style&index=0&id=16ddd5e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ddd5e6",
  null
  
)

export default component.exports